import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import * as Yup from "yup";
import Modal from "@mui/material/Modal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import "../../../../styles/Layout/Admin_Styles/_DegreeModal.scss";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Tooltip } from "@mui/material";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import { authHttp } from "../../../services/utility";
import { apisPath } from "../../../../utils/path";
import { AuthContext } from "../../../../context/AuthContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: 24,
};

const defaultValues = {
  qualification_id: "",
  name: "",
};

export default function BasicModal(_props) {
  const { open, handleClose, qualification_id, handleAddDegree } = _props;

  const { setIsLoading, setAlertState, setIsTableLoading, setToastState } = React.useContext(AuthContext);

  const DegreeSchema = Yup.object().shape({
    // qualification_id: Yup.string().nullable().required("Qualification Type is required"),
    name: Yup.string().trim().nullable().required("Degree Name is required").max(100,'Degree Name should be less than or equal to 100 characters'),
  });

  const submitHandler = async (data, { resetForm }) => {
    setIsLoading(true);
    const tempData = { ...data };
    authHttp
      .post(apisPath?.admin?.addDegree, { ...tempData, qualification_id: qualification_id })
      .then((res) => {
        setToastState((prev) => ({ ...prev, open: true, msg: res?.data?.msg }));
        resetForm()
        setIsLoading(false)
        setIsTableLoading(true)
        handleAddDegree()
      })
      .catch((err) => {
        resetForm()
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  return (
    <div className="degree-modal">

      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="degree-modal--backdrop"
      >
        <Box sx={style} className="degree-modal--boxinfo">
          <div className="degree-modal--header">
            <h2>Add Degree</h2>
            <Tooltip title="Close">
              <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
          <div className="degree-modal--wrapper">
            <Formik
              initialValues={defaultValues}
              validationSchema={DegreeSchema}
              onSubmit={submitHandler}
            >
              {({
                handleChange,
                values,
                handleSubmit,
                errors,
                touched,
                handleBlur,
                setFieldValue,
                isValid,
                isSubmitting,
                dirty,
                resetForm,
              }) => (
                <>
                  {/* <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="degree--select">
                        <FormControl fullWidth>
                          <InputLabel id="qualification_id-label">
                            Select Qualification Type *
                          </InputLabel>
                          <Select
                            autoComplete="off"
                            labelId="qualification_id-label"
                            id="qualification_id"
                            label="Qualification Type"
                            name="qualification_id"
                            value={values?.qualification_id}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyUp={handleBlur}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  maxHeight: "250px",
                                  overflowY: "auto",
                                },
                              },
                            }}
                          >
                            {qualifications?.map((qual) => (
                              <MenuItem value={qual?.id}>{qual?.name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {errors?.qualification_id &&
                          touched?.qualification_id && (
                            <p className="text-danger">
                              {errors?.qualification_id}
                            </p>
                          )}
                      </div>
                    </Grid>
                  </Grid> */}
                  <Grid container spacing={2} sx={{ marginTop: 1 }}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        autoComplete="off"
                        fullWidth
                        name="name"
                        value={values?.name}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        id="name"
                        label="Degree Name *"
                        variant="outlined"
                        onDrop={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        onBlur={handleBlur}
                        onKeyUp={handleBlur}
                      />
                      {errors?.name && touched?.name && (
                        <p className="text-danger">{errors?.name}</p>
                      )}
                    </Grid>
                  </Grid>

                  <div className="degree-modal--button-wrapper">
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleSubmit}
                      className="degree-modal--button"
                    >
                      Add
                    </Button>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
